import { cn } from "@/lib/utils"
import type { ReactNode, HTMLAttributes, ButtonHTMLAttributes } from "react"

export const taskCreateTheme = {
  triggerButton: cn(
    "font-bold text-xl lg:text-2xl px-8 py-6 rounded-3xl shadow-2xl shadow-purple-500/30 transition-all hover:scale-[1.03]",
    "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white"
  ),

  dialogContent: "bg-purple-950/70 backdrop-blur-2xl border border-purple-300/40 text-white max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl",

  formLabel: "text-sm font-medium text-purple-300",
  formInput: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white rounded-2xl",
  formTextarea: "bg-purple-950/60 border-purple-300/40 focus:border-purple-400 focus:ring-purple-400 text-white rounded-2xl",

  selectTrigger: "bg-purple-950/60 border-purple-300/40 text-white hover:border-purple-400 rounded-2xl",
  selectContent: "bg-purple-950/90 border-purple-300/40 backdrop-blur-2xl text-white shadow-2xl rounded-3xl",
  selectItem: "hover:bg-purple-900/60 text-purple-200",

  badgeCoAssignee: "bg-purple-600 text-white",
  badgeObserver: "bg-amber-700/80 text-white",

  fileUploadArea: "flex items-center gap-2 bg-purple-950/60 hover:bg-purple-950/80 text-purple-200 border border-purple-300/40 px-4 py-3 rounded-2xl transition cursor-pointer",

  createButton: "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-3xl",

  sectionTitle: "text-2xl",
} as const

export function StyledDialogTriggerButton({
  children,
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={cn(taskCreateTheme.triggerButton, className)}
      {...props}
    >
      {children}
    </button>
  )
}

export function StyledDialogContent({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(taskCreateTheme.dialogContent, className)}
      {...props}
    >
      {children}
    </div>
  )
}

export function StyledFormInput({
  className,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn(taskCreateTheme.formInput, className)} {...props} />
}

export function StyledFormTextarea({
  className,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cn(taskCreateTheme.formTextarea, className)} {...props} />
}

export function StyledSelectTrigger({
  className,
  ...props
}: HTMLAttributes<HTMLButtonElement>) {
  return <button className={cn(taskCreateTheme.selectTrigger, className)} {...props} />
}

export function StyledFileUploadArea({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(taskCreateTheme.fileUploadArea, className)}
      {...props}
    >
      {children}
    </div>
  )
}